import { render } from "./StakeButton.vue?vue&type=template&id=3f03aaf4&scoped=true"
import script from "./StakeButton.vue?vue&type=script&lang=js"
export * from "./StakeButton.vue?vue&type=script&lang=js"

import "./StakeButton.vue?vue&type=style&index=0&id=3f03aaf4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f03aaf4"]])

export default __exports__